(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-product-grid"] && !Shopify.designMode) return;
  try {
    
  // Karuzela w karcie — przewijanie o jeden slajd, delegacja zdarzeń,
  // więc działa też dla kart doładowanych przez infinite scroll.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-racer-prev], [data-racer-next]');
    if (!button) return;

    event.preventDefault();

    const gallery = button.closest('.racer-card__gallery');
    const track = gallery?.querySelector('[data-racer-track]');
    if (!track) return;

    const direction = button.hasAttribute('data-racer-next') ? 1 : -1;
    const step = track.clientWidth;
    let target = track.scrollLeft + direction * step;

    // Zawijanie na końcach, żeby karuzela była nieskończona jak u Racera.
    const max = track.scrollWidth - step;
    if (target > max + 1) target = 0;
    if (target < -1) target = max;

    track.scrollTo({ left: target, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-reels"] && !Shopify.designMode) return;
  try {
    
  // Wideo startuje dopiero w widoku i zatrzymuje sie poza nim —
  // inaczej pieć rolek naraz zjadałoby transfer i baterie.
  (function () {
    const reels = document.querySelectorAll('[data-racer-reel]');
    if (!reels.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.preload = 'auto';
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '100px', threshold: 0.25 }
    );

    reels.forEach((video) => io.observe(video));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-tabs"] && !Shopify.designMode) return;
  try {
    
  class RacerTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length === 0) return;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      });

      this.addEventListener('keydown', (event) => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;

        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = current === last ? 0 : current + 1;
        if (event.key === 'ArrowLeft') next = current === 0 ? last : current - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        if (next !== null) {
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');

        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !selected;
      });
    }
  }

  if (!customElements.get('racer-tabs')) {
    customElements.define('racer-tabs', RacerTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
